import TcnAuBtn from "./TcnAuBtn.vue"
export default TcnAuBtn;